import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo1 from "../../assets/logo1.svg";
import logo2 from "../../assets/logo2.svg";
import infoicon from "../../assets/infoicon.svg";
import CustomButton from "../CustomButton";
import LanguageSwitcher from "../LanguageSwitcher";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import projectlogo from "../../assets/projectlogo.png";
import websitelogo from "../../assets/websitelogo.png";
const RegisterHeader = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleLogin = () => {
    navigate("/");
  };
 const logoToShow = i18n.language === "es" ? websitelogo : projectlogo;
  return (
    <AppBar
      position="fixed"
      color="white"
      elevation={0}
      sx={{ backgroundColor: "white", py: 0.6, px: 2 }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* Left Section (Logo) */}
        <Box display="flex" alignItems="center" gap={1.5}>
          <img
            src={logoToShow}
            style={{ height: 70, width: 180, objectFit: "contain" }}
          />
        </Box>

        {/* Right Section */}
        {isMobile ? (
          <IconButton onClick={handleMenuToggle}>
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        ) : (
          <Box display="flex" alignItems="center" gap={1.4}>
            {/* Info Tooltip */}
       

            <LanguageSwitcher variant="header" />

            <CustomButton
              label={t("loginButton")}
              onClick={handleLogin}
              buttonVariant="primary"
              size="medium"
            />
          </Box>
        )}
      </Toolbar>

      {/* Mobile Dropdown */}
      {isMobile && menuOpen && (
        <Box
          sx={{
            px: 2,
            pb: 2,
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {/* Info Icon */}
     
     

          {/* Language Dropdown in Mobile View */}
          <LanguageSwitcher variant="header" />

          <CustomButton
            label={t("loginButton")}
            onClick={handleLogin}
            buttonVariant="primary"
            size="medium"
          />
        </Box>
      )}
    </AppBar>
  );
};

export default RegisterHeader;
